var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.596 7.992l-.792-1.056v-1.92a3.82 3.82 0 00-2.472-3.564C6.332.816 5.804.3 5.168.3H4.82c-.636 0-1.164.516-1.164 1.164a3.808 3.808 0 00-2.472 3.564v1.92L.392 8.004a1.13 1.13 0 00-.108 1.164c.18.384.564.612.996.612h1.764c0 1.068.876 1.944 1.944 1.944A1.944 1.944 0 006.932 9.78h1.764a1.12 1.12 0 00.9-1.788z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS41OTYgNy45OTJsLS43OTItMS4wNTZ2LTEuOTJhMy44MiAzLjgyIDAgMCAwLTIuNDcyLTMuNTY0QzYuMzMyLjgxNiA1LjgwNC4zIDUuMTY4LjNINC44MmMtLjYzNiAwLTEuMTY0LjUxNi0xLjE2NCAxLjE2NGEzLjgwOCAzLjgwOCAwIDAgMC0yLjQ3MiAzLjU2NHYxLjkyTC4zOTIgOC4wMDRhMS4xMyAxLjEzIDAgMCAwLS4xMDggMS4xNjRjLjE4LjM4NC41NjQuNjEyLjk5Ni42MTJoMS43NjRjMCAxLjA2OC44NzYgMS45NDQgMS45NDQgMS45NDRBMS45NDQgMS45NDQgMCAwIDAgNi45MzIgOS43OGgxLjc2NGExLjEyIDEuMTIgMCAwIDAgLjktMS43ODh6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4K";
export { SvgIconBell as ReactComponent };